import { render, staticRenderFns } from "./solidBarChart.vue?vue&type=template&id=010ae954&scoped=true"
import script from "./solidBarChart.vue?vue&type=script&lang=js"
export * from "./solidBarChart.vue?vue&type=script&lang=js"
import style0 from "./solidBarChart.vue?vue&type=style&index=0&id=010ae954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010ae954",
  null
  
)

export default component.exports